<main>
  <div class="container">
    <div class="topheadtitle">
      <h4>Error Doc Search</h4>
    </div>

    @if (!showReportResults) {
      <div class="form-box">
        <div class=" formPage">
          <form [formGroup]="errorDocSearchForm">
            <label class="fw-600" for="citationNumber" style="margin-right: 6px;">Citation number</label>
            <input type="text" formControlName="citationNumber" id="citationNumber" placement="top"
              triggers="mouseenter:mouseleave"
              ngbPopover="A minimum of 1 initial character entry is needed for a specific citation search"
              class="Input-width" />
              <span class="text-para " style="margin: 0 28px 0 10px;">Alphanumeric Characters only - please do not
                include the information
                <i>after</i>
              the dash</span>
              <hr />
              <div class="destination">
                <label class="fw-600" for="errorType" style="margin-right: 50px;">Error Type</label>
                <select formControlName="errorType" id="errorType" multiple>
                  <option value="ALL">All</option>
                  <option value="Failed Delivery">Failed Delivery</option>
                  <option value="Rejected Delivery">Rejected Delivery</option>
                  <option value="Invalid Schema">Invalid Schema</option>
                  <option value="Invalid Citation Number">Invalid Citation Number</option>
                  <option value="Invalid Disposition Code">Invalid Disposition Code</option>
                  <option value="Duplicate Citation">Duplicate Citation</option>
                </select>
                <span class="text-para " style="margin: 0 28px 0 10px;">Multiple Selections Allowed</span>
              </div>
              <hr />
              <span id="date-examples" class="DateExample " style="margin-left: 105px;">Date Examples:
              mm/dd/yyyy</span>
              <!-- Created date group: give inputs an accessible name via aria-labelledby and connect the hint -->
              <div class="box-date" aria-labelledby="created-legend"
                aria-describedby="created-hint date-examples">
                <span id="created-legend" class="fw-600" style="margin-right: 28px;">Created date</span>
                <input type="date" title="created start date" formControlName="createDateStart" id="createDateStart"
                  class="Input-width" aria-labelledby="created-legend"
                  aria-describedby="created-hint date-examples" />
                  <span aria-hidden="true"> to</span>
                  <input type="date" title="created end date" formControlName="createDateEnd" id="createDateEnd"
                    class=" Input-width" aria-labelledby="created-legend"
                    aria-describedby="created-hint date-examples" />
                    <span id="created-hint" class="text-para">Enter just one date if a single date is
                    desired</span><br />
                  </div>
                  <hr />
                  <div class="formpage-btn">
                    <button type="submit" class="btn-Submit" (click)="searchErrorDoc()">Search</button>&nbsp; &nbsp;
                    <button type="button" class="btn-Submit" (click)="resetForm()">Reset</button>
                  </div>
                </form>
              </div>
            </div>
          }

          @if (showReportResults) {
            <div>
              @if (alert) {
                <div class="alert alert-success" role="alert" aria-live="polite">{{alert.message}}</div>
              }
              @if (showReportResults) {
                <div class="table-container mt-2">
                  <div class="btn-group mb-2">
                    @if (authType.menuType === 'ROLE_ADMIN' && userTypeView === 'S') {
                      <button type="button"
                        class="btn btn-outline-primary" (click)="deleteSelected()">
                        Delete
                      </button>
                    }
                  </div>
                  <table class="table">
                    <caption>Error Doc Search Results</caption>
                    <thead>
                      <tr>
                        @if (authType.menuType === 'ROLE_ADMIN') {
                          <th width="5%" scope="col"></th>
                        }
                        <!-- Make sortable headers keyboard-accessible -->
                        <th width="15%" scope="col" (click)="onSort($event,'citationNumber',true)" tabindex="0"
                          [attr.role]="'button'" (keydown.enter)="onSort($event,'citationNumber',true)"
                          (keydown.space)="onSort($event,'citationNumber',true)" aria-label="Sort by Citation Number">
                          Citation Number <i title="Sort Citation number" class="fa fa-sort" aria-hidden="true"></i>
                        </th>
                        <th width="20%" scope="col" (click)="onSort($event,'createTime',true)" tabindex="0"
                          [attr.role]="'button'" (keydown.enter)="onSort($event,'createTime',true)"
                          (keydown.space)="onSort($event,'createTime',true)" aria-label="Sort by Created Time">
                          Created Time <i title="Sort Created time" class="fa fa-sort" aria-hidden="true"></i>
                        </th>
                        <th width="60%" scope="col">Narrative</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (item of getItems(); track item; let i = $index) {
                        <tr>
                          @if (authType.menuType === 'ROLE_ADMIN') {
                            <td>
                              <input type="checkbox" aria-label="select citation" [checked]="isSelected(item)"
                                (change)="toggleSelection(item)" />
                              </td>
                            }
                            <td>{{item.citationNumber}}</td>
                            <td>{{item.createTime}}</td>
                            <td>{{item.narrative}}</td>
                          </tr>
                        }
                      </tbody>
                    </table>
                    <div class="text-center"> {{searchQuery()}}</div>
                    <div class="d-flex justify-content-between align-items-center">
                      <div>
                        <span>{{outPut.totalElements}} items found, displaying {{getCurrentPageTotal()}} of
                        {{outPut.totalElements}}</span>
                      </div>
                      <ngb-pagination [collectionSize]="outPut.totalElements" [(page)]="currentPage" [ellipses]="true"
                        [maxSize]="10" (pageChange)="onPageChange(currentPage)" [pageSize]="pageSize" [boundaryLinks]="true"
                      aria-label="Error doc results pagination"></ngb-pagination>
                      <br />
                      <button type="button" class="btn btn-outline-primary"
                        (click)="showReportResults = false;resetForm();selectedItems =[]; alertService.clear()">
                        Go back to previous page
                      </button>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </main>